module.exports = __webpack_public_path__ + "media/images/firsttime_contents02_sp-3d560ec582fd3e97b944e7f1dc28c82a.png";